import { useEffect, useRef } from 'react';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { Text } from 'src/modules/shared/components/atoms/text';
import type { UndoToastProps } from 'src/modules/shared/types/deferred-action.types';

/** Compact, keyboard-accessible undo prompt for a pending action. */
export const UndoToast = ({
  message,
  undoLabel,
  remaining,
  onUndo,
  focusUndo = false,
}: UndoToastProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (focusUndo) buttonRef.current?.focus();
  }, [focusUndo]);
  return (
    <div className="overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-lg">
      <div className="flex items-center gap-4 px-4 py-3">
        <div role="status" className="min-w-0 flex-1">
          <Text size="small" className="break-words">
            {message}
          </Text>
        </div>
        <Button
          ref={buttonRef}
          variant="primary"
          appearance="ghost"
          size="sm"
          onClick={onUndo}
        >
          {undoLabel}
        </Button>
      </div>
      <div aria-hidden="true" className="h-1 bg-neutral-100">
        <div
          className="h-full bg-primary-500"
          style={{ width: `${Math.max(0, remaining) * 100}%` }}
        />
      </div>
    </div>
  );
};
